import headline from './Headline/template'
import text from './Text/template'
import spacer from './Spacer/template'
import button from './Button/template'
import rank from './Rank/template'
import image from './Image/template'
import field from './Field/template'
import textarea from './Textarea/template'
import social from './Social/template'
import { surveyDefaultTemplate as survey } from './Survey/template'
import {
  fortuneWheelWidgetDefaultTemplate as wheel,
} from './FortuneWheel/template'
import voucher from './Voucher/template'
import checkbox from './Checkbox/template'
import countdown from './Countdown/template'

// Centralized mapping for theme fontFamily updates
export const itemsWithFontFamily = [
  'headline',
  'text',
  'image',
  // spacer, no fontFamily
  'button',
  'social',
  // rank, no fontFamily
  'field',
  'textarea',
  'survey',
  'wheel',
  'voucher',
  'checkbox',
  'countdown',
]

// Centralized mapping for theme color updates
export const themePropertyMapping = {
  primaryColor: {
    button: ['color', 'borderColor'],
    // image: ['color', 'backgroundColor'], no need
    field: ['color', 'borderColor'],
    textarea: ['color', 'borderColor'],
    survey: ['color', 'borderColor'],
    checkbox: ['color', 'borderColor', 'checkboxColor'],
    wheel: ['color'],
    // Add other content items and their affected properties
  },
  secondaryColor: {
    rank: ['baseColor'],
    voucher: ['color', 'borderColor'],
    countdown: ['color', 'borderColor'],
    headline: ['color'],
    text: ['color'],
    button: ['backgroundColor'],
    survey: ['backgroundColor'],
    field: ['backgroundColor'],
    textarea: ['backgroundColor'],
    social: ['color'],
    checkbox: ['backgroundColor'],
    wheel: ['backgroundColor', 'secondaryBackgroundColor'],
    // Add other content items and their affected properties
  },
}

export {
  headline,
  text,
  image,
  spacer,
  button,
  social,
  rank,
  field,
  textarea,
  survey,
  wheel,
  voucher,
  checkbox,
  countdown,
}